module.exports = __FOREMAN_VENDOR__URIJS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__URIJS__"
// module id = urijs
// module chunks = 0